module.exports = __webpack_public_path__ + "img/bgTitle5.610838e3.png";